<template lang="html">
  <div class="page-register">
    <Notification
      v-if="notification.active"
      :withinOverlay="true"
      :content="notification.content"
      :type="notification.type"
    />

    <RegisterForm v-model="user" :errors="errors" @submit="register" />
  </div>
</template>

<script>
import {createPublicUserData} from '@/lib/users'

import RegisterForm from '@/components/forms/RegisterForm'

import notification from '@/mixins/notification'

export default {
  name: 'register',

  mixins: [notification],

  components: {
    RegisterForm
  },

  data() {
    return {
      user: {
        acceptPromo: true
      },
      errors: {}
    }
  },

  computed: {
    formPayload() {
      return {
        name: this.user.name,
        company_name: this.user.companyName,
        email: this.user.email,
        accept_terms: this.user.acceptTerms,
        accept_promo: this.user.acceptPromo,
        referral: this.referral
      }
    },

    referral() {
      let query = this.$route.query
      let host = {url: window.location.host}
      let referral = {host, query}

      return JSON.stringify(referral) || {}
    }
  },

  methods: {
    register() {
      createPublicUserData(this.formPayload)
        .then((response) => {
          if (response.message) {
            this.triggerNotification(
              'unsuccessful',
              'registration',
              'try again later'
            )
          } else {
            this.redirectToLogin()
          }
        })
        .catch((response) => {
          this.errors = response.errors
        })
    },

    redirectToLogin() {
      this.$router.push({
        name: 'login',
        query: {inviteSent: true}
      })
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-register
  display: flex
  flex-direction: row
  width: 100%
  align-items: center
  height: calc(100vh - #{$header-height})

  @include themify($themes)
    background: themed('color-secondary')

  h1
    text-align: center
</style>
